"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableCellValuePersonProperty = exports.resultsTableCellValuePersonPropertyDefinition = void 0;
exports.resultsTableCellValuePersonPropertyDefinition = {
    view: { label: 'Results Table Cell Value Person' },
    constraints: [
        {
            name: 'stencils',
            argument: ['artist', 'athlete'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'results-table-cell-value-person',
};
const isResultsTableCellValuePersonProperty = (prop) => {
    return prop.name === exports.resultsTableCellValuePersonPropertyDefinition.name;
};
exports.isResultsTableCellValuePersonProperty = isResultsTableCellValuePersonProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jZWxsLXZhbHVlLXBlcnNvbi5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtY2VsbC12YWx1ZS1wZXJzb24ucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw2Q0FBNkMsR0FBRztJQUMzRCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsaUNBQWlDLEVBQUU7SUFDbEQsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsQ0FBQyxRQUFRLEVBQUUsU0FBUyxDQUFDO1NBQ2hDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGlDQUFpQztDQUNSLENBQUE7QUFJMUIsTUFBTSxxQ0FBcUMsR0FBRyxDQUFDLElBQWtCLEVBQStDLEVBQUU7SUFDdkgsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFEQUE2QyxDQUFDLElBQUksQ0FBQTtBQUN6RSxDQUFDLENBQUE7QUFGWSxRQUFBLHFDQUFxQyx5Q0FFakQifQ==